import { useAppTheme } from "@hooks/useAppTheme";
import { useDevice } from "@hooks/useDevice";
import OnboardingLayout from "@memorang/ui/components/OnboardingLayout";
import SetExamDateContainer from "components/SetExamDateContainer";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pressable, View } from "react-native";
import { Text, TextInput } from "react-native-paper";

type Props = {
	handleNext: () => void;
	testDate?: string;
	onDateChange: (date: Date) => void;
	cta?: string;
};
const ChooseTestDataScreen = ({
	handleNext,
	testDate,
	onDateChange,
	cta = "Confirm date",
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const { isMobile } = useDevice();
	const [showDatePicker, setShowDatePicker] = useState(false);

	const openDatePicker = () => {
		setShowDatePicker(true);
	};

	const closeDatePicker = () => {
		setShowDatePicker(false);
	};

	return (
		<OnboardingLayout
			onPrimaryPress={handleNext}
			disabled={!testDate}
			primaryActionLabel={cta}
		>
			<View
				style={{
					paddingHorizontal: isMobile ? 16 : 0,
				}}
			>
				<Pressable onPress={openDatePicker} style={{ cursor: "pointer" }}>
					<TextInput
						placeholder="Date"
						mode="outlined"
						pointerEvents="none"
						editable={false}
						value={testDate}
						right={<TextInput.Icon icon="calendar" onPress={openDatePicker} />}
					/>
				</Pressable>

				<Text
					variant="bodyLarge"
					style={{
						color: theme.palette.text.secondary,
						textAlign: "center",
						marginTop: 16,
					}}
				>
					{t("onboarding.steps.testDate.bottomLabel")}
				</Text>

				<SetExamDateContainer
					showDatePicker={showDatePicker}
					toggleShowDatePicker={closeDatePicker}
					handleDateChange={onDateChange}
				/>
			</View>
		</OnboardingLayout>
	);
};

export default ChooseTestDataScreen;
